class ModalHandler {
    constructor() {
        this.triggers = document.querySelectorAll(".pop_up_modal");
        this.modals = document.querySelectorAll(".modal");
        this.bindEvents();
    }

    bindEvents() {
        this.triggers.forEach(trigger => {
            const blockId = trigger.getAttribute("data-block-id");
            const modal = document.querySelector(`.modal[data-block-id="${blockId}"]`);

            if (!modal) return;

            trigger.addEventListener("click", () => this.openModal(modal));
            
            const closeBtn = modal.querySelector(".close");
            if (closeBtn) {
                closeBtn.addEventListener("click", () => this.closeModal(modal));
            }

            modal.addEventListener("click", (event) => {
                if (!event.target.closest(".modal-content")) {
                    this.closeModal(modal);
                }
            });
        });
    }

    openModal(modal) {
        this.closeAllModals();
        modal.style.display = "block";
    }

    closeModal(modal) {
        modal.style.display = "none";
    }

    closeAllModals() {
        this.modals.forEach(modal => modal.style.display = "none");
    }
}

new ModalHandler();
